import React from 'react';
import InputTitleView from './InputTitleView';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { getDotFormatDateFns } from 'Util/DateUtils';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ko, vi } from 'date-fns/locale';

const customFieldStyle = {
  '& .MuiOutlinedInput-root': {
    fieldset: {
      border: '1px solid #C4C4C4',
      height: '44px',
      width: '380px',
    },
    '&:hover fieldset': {
      borderColor: '#C4C4C4',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #C4C4C4',
    },
    '&.Mui-error fieldset': {
      border: '1px solid #C4C4C4',
    },
  },
};
const DateInputView = ({ title = '', required = false, subTitle = '', placeholder, name, value, onChange }) => {
  const { locale } = useSelector(state => state.settings.locale);
  return (
    <div className="recruitment-date-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className="recruitment-date-input-view-input-wrapper">
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale === 'vi' ? vi : ko}>
          <DatePicker
            inputFormat={getDotFormatDateFns(locale)}
            className="datePicker"
            id="date"
            value={value}
            onChange={e => onChange({ name, value: e })}
            renderInput={params => (
              <TextField
                {...params}
                sx={customFieldStyle}
                placeholder={placeholder}
                inputProps={{
                  ...params.inputProps,
                  placeholder,
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default DateInputView;
